var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isDisplay
    ? _c(
        "div",
        {
          staticClass: "preview-item_free",
          style: { "padding-left": _vm.paddingLeft }
        },
        _vm._l(_vm.formNode.children, function(el) {
          return _c("preview-item-template", {
            key: el.id,
            attrs: { formNode: el, parent: _vm.formNode.children }
          })
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7592bfdc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7592bfdc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preview_item/PreviewItemFree.vue
// module id = null
// module chunks = 